import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { assertNever } from '../utils/assert-never';
import { BeaconMessageType } from '..';
import { Logger } from '../utils/Logger';
var logger = new Logger('IncomingRequestInterceptor');
/**
 * @internalapi
 *
 * The IncomingRequestInterceptor is used in the WalletClient to intercept an incoming request and enrich it with data, like app metadata.
 */

export var IncomingRequestInterceptor = /*#__PURE__*/function () {
  function IncomingRequestInterceptor() {
    _classCallCheck(this, IncomingRequestInterceptor);
  }

  _createClass(IncomingRequestInterceptor, null, [{
    key: "intercept",
    value:
    /**
     * The method that is called during the interception
     *
     * @param config
     */
    function intercept(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var message, connectionInfo, appMetadataManager, interceptorCallback, request, appMetadata, _request, _appMetadata, _request2, _appMetadata2, _request3;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                message = config.message, connectionInfo = config.connectionInfo, appMetadataManager = config.appMetadataManager, interceptorCallback = config.interceptorCallback; // TODO: Remove v1 compatibility in later version

                if (message.beaconId && !message.senderId) {
                  message.senderId = message.beaconId;
                  delete message.beaconId;
                }

                _context.t0 = message.type;
                _context.next = _context.t0 === BeaconMessageType.PermissionRequest ? 5 : _context.t0 === BeaconMessageType.OperationRequest ? 11 : _context.t0 === BeaconMessageType.SignPayloadRequest ? 17 : _context.t0 === BeaconMessageType.BroadcastRequest ? 23 : 29;
                break;

              case 5:
                // TODO: Remove v1 compatibility in later version
                if (message.appMetadata.beaconId && !message.appMetadata.senderId) {
                  message.appMetadata.senderId = message.appMetadata.beaconId;
                  delete message.appMetadata.beaconId;
                }

                _context.next = 8;
                return appMetadataManager.addAppMetadata(message.appMetadata);

              case 8:
                request = message;
                interceptorCallback(request, connectionInfo);
                return _context.abrupt("break", 31);

              case 11:
                _context.next = 13;
                return IncomingRequestInterceptor.getAppMetadata(appMetadataManager, message.senderId);

              case 13:
                appMetadata = _context.sent;
                _request = Object.assign({
                  appMetadata: appMetadata
                }, message);
                interceptorCallback(_request, connectionInfo);
                return _context.abrupt("break", 31);

              case 17:
                _context.next = 19;
                return IncomingRequestInterceptor.getAppMetadata(appMetadataManager, message.senderId);

              case 19:
                _appMetadata = _context.sent;
                _request2 = Object.assign({
                  appMetadata: _appMetadata
                }, message);
                interceptorCallback(_request2, connectionInfo);
                return _context.abrupt("break", 31);

              case 23:
                _context.next = 25;
                return IncomingRequestInterceptor.getAppMetadata(appMetadataManager, message.senderId);

              case 25:
                _appMetadata2 = _context.sent;
                _request3 = Object.assign({
                  appMetadata: _appMetadata2
                }, message);
                interceptorCallback(_request3, connectionInfo);
                return _context.abrupt("break", 31);

              case 29:
                logger.log('intercept', 'Message not handled');
                assertNever(message);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "getAppMetadata",
    value: function getAppMetadata(appMetadataManager, senderId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var appMetadata;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return appMetadataManager.getAppMetadata(senderId);

              case 2:
                appMetadata = _context2.sent;

                if (appMetadata) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('AppMetadata not found');

              case 5:
                return _context2.abrupt("return", appMetadata);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return IncomingRequestInterceptor;
}();